import UsageAndEfficiencyChart from "./UsageAndEfficiencyChart";

export default UsageAndEfficiencyChart;
